var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C17.1 20 18.0417 19.6083 18.825 18.825C19.6083 18.0417 20 17.1 20 16C20 14.9 19.6083 13.9583 18.825 13.175C18.0417 12.3917 17.1 12 16 12C14.9 12 13.9583 12.3917 13.175 13.175C12.3917 13.9583 12 14.9 12 16C12 17.1 12.3917 18.0417 13.175 18.825C13.9583 19.6083 14.9 20 16 20ZM16 34.7C20.0667 30.9667 23.0833 27.575 25.05 24.525C27.0167 21.475 28 18.7667 28 16.4C28 12.7667 26.8417 9.79167 24.525 7.475C22.2083 5.15833 19.3667 4 16 4C12.6333 4 9.79167 5.15833 7.475 7.475C5.15833 9.79167 4 12.7667 4 16.4C4 18.7667 4.98333 21.475 6.95 24.525C8.91667 27.575 11.9333 30.9667 16 34.7ZM16 40C10.6333 35.4333 6.625 31.1917 3.975 27.275C1.325 23.3583 0 19.7333 0 16.4C0 11.4 1.60833 7.41667 4.825 4.45C8.04167 1.48333 11.7667 0 16 0C20.2333 0 23.9583 1.48333 27.175 4.45C30.3917 7.41667 32 11.4 32 16.4C32 19.7333 30.675 23.3583 28.025 27.275C25.375 31.1917 21.3667 35.4333 16 40Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.710833512294bddcfc11e2340fb145ad.svg";
export { ForwardRef as ReactComponent };